<script lang="ts" setup name="SectionCard">
const {
  title = '',
  subTitle = '',
  border = false,
  padding = true,
  paddingBottom = true,
  shadow = false,
} = defineProps<{
  title?: string;
  subTitle?: string;
  border?: boolean;
  padding?: boolean;
  paddingBottom?: boolean;
  shadow?: boolean;
}>();
</script>

<template>
  <div
    class="overflow-hidden rounded-lg bg-white pt-8 shadow"
    :class="{ 'pb-4': paddingBottom }"
  >
    <div
      class="flex items-baseline border-b px-6 pb-4"
      :class="{
        'border-transparent': !border,
        'border-charcoal-2': border,
      }"
    >
      <div class="flex-1">
        <p class="text-subtitle-1 text-charcoal-9">{{ title }}</p>
        <p v-if="subTitle" class="mt-2 text-sm leading-4">
          {{ subTitle }}
        </p>
      </div>

      <div v-if="$slots.actions" class="flex-shrink-0">
        <slot name="actions" />
      </div>
    </div>
    <div :class="{ 'shadow-lg': shadow, 'px-6': padding }">
      <slot />
    </div>
  </div>
</template>
